import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CommitteeFilter = ({
  selectedCommittee,
  onCommitteeChange,
  committees,
  getCount,
}) => {
  const getSelectedCommitteeName = () => {
    if (!selectedCommittee) {
      return 'Filter by Sectional Committee';
    }

    const committee = committees.find(
      (item) => item.id === parseInt(selectedCommittee),
    );

    return committee?.attributes.name || 'Filter by Sectional Committee';
  };

  return (
    <DropdownButton
      id="dropdown-committee-filter"
      variant="outline-primary"
      title={getSelectedCommitteeName()}
    >
      <Dropdown.Item onClick={() => onCommitteeChange(null)}>All</Dropdown.Item>
      {committees.map((item) => {
        const count = getCount ? getCount(item.id) : null;
        const hasNoCandidates = count === 0;

        return (
          <Dropdown.Item
            key={item.id}
            onClick={() => !hasNoCandidates && onCommitteeChange(item.id)}
            disabled={hasNoCandidates}
            className={hasNoCandidates ? 'text-muted' : ''}
          >
            {item.attributes.name}
            {count !== null && (
              <span
                className={`ms-2 ${hasNoCandidates ? 'text-muted' : 'text-primary'}`}
              >
                ({count})
              </span>
            )}
          </Dropdown.Item>
        );
      })}
    </DropdownButton>
  );
};

CommitteeFilter.propTypes = {
  selectedCommittee: PropTypes.number,
  onCommitteeChange: PropTypes.func.isRequired,
  committees: PropTypes.array.isRequired,
  getCount: PropTypes.func,
};

export default CommitteeFilter;
